import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 44239 42749"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:490.248}.fil0{fill:#231f20}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613593120">
        <path
          d="M20261 23029c-968 0-1754 785-1754 1754s786 1754 1754 1754c969 0 1754-785 1754-1754s-785-1754-1754-1754z"
          className="fill stroke1"
          style={{
            strokeWidth: 490.248,
          }}
        />
        <path
          d="M20261 27345c-1414 0-2561-1148-2561-2562s1147-2560 2561-2560c1415-1 2561 1146 2561 2560s-1146 2562-2561 2562zm0-6416c-2129 0-3854 1725-3854 3854s1725 3855 3854 3855 3854-1726 3854-3855-1725-3854-3854-3854z"
                    className="fill stroke1"
          style={{
            strokeWidth: 490.248,
          }}

        />
        <path
          d="M29683 16381c-213-2262-852-4330-1665-6140-1947-4334-5502-7741-9857-9638-2240-975-4841 111-5720 2391-490 1270-1122 2892-1928 4943-2856 7261-245 8933 4609 10035 2274 515 3160 1622 3460 2653 519-210 1085-329 1679-329 1736 0 3238 987 3984 2429 2941-572 5833-2178 5438-6344zM17501 28315c-1049-821-1726-2096-1726-3532 0-893 263-1721 713-2421-1966-2260-4804-3962-8214-1537-1851 1316-3324 2903-4485 4512-2780 3853-3952 8636-3418 13355 276 2428 2516 4137 4930 3759 1346-211 3065-476 5246-802 7715-1158 7858-4255 6385-9010-691-2228-175-3548 569-4324zM43042 28905c-856-1059-1945-2417-3318-4141-4860-6103-7613-4679-10994-1026-1585 1713-2988 1926-4030 1669-305 2182-2173 3863-4439 3863-70 0-139-7-208-11-976 2834-1032 6143 2774 7885 2065 945 4176 1427 6151 1628 4726 481 9454-894 13273-3718 1966-1452 2325-4247 791-6149z"
                    className="fill stroke1"
          style={{
            strokeWidth: 490.248,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
